import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function RefundPage(): React.JSX.Element {
  return (
    <ComplianceDocument
      slug="refund-policy"
      title="Refund Policy"
      description={
        <span>
          This Refund Policy explains our guidelines regarding refunds for <strong>kivo.skin</strong>. We strive to provide transparent policies for our users.
        </span>
      }
    />
  );
}
